import React, { useEffect, useState } from "react";
import FileChonky from "./chonky/index";
import { Modal } from "antd";
import { LocalImage } from "./ImageUtil";

export default function UploadFileProp({
  onUploadPc,
  onUploadMb,
  image,
  type,
}) {
  const [show, setShow] = useState(false);
  const [imageUrl, setImageUrl] = useState(image);

  useEffect(() => {
    setImageUrl(image);
  }, [image]);

  const onSelected = (url) => {
    setShow(!show);
    setImageUrl(url);

    if (type === "first") {
      onUploadPc(url);
    } else {
      onUploadMb(url);
    }
  };
  const showWindow = () => {
    setShow(!show);
  };

  return (
    <>
      <div>
        <div style={{ cursor: "pointer" }}>
          <LocalImage
            src={imageUrl}
            onClick={showWindow}
            preview={false}
            style={{ objectFit: "contain" }}
            width={200}
            height={200}
          />
        </div>

        {show && (
          <Modal
            title=""
            visible={show}
            width={1300}
            style={{ top: 20 }}
            okButtonProps={{
              disabled: true,
            }}
            onCancel={() => {
              setShow(false);
            }}
            destroyOnClose={true}
          >
            <div style={{ padding: "15px" }}>
              <FileChonky onSelected={onSelected} /> 
              <br />
            </div>
          </Modal>
        )}
      </div>
    </>
  );
}
